<template>
  <el-form
    :model="addForm"
    ref="addForm"
    label-width="110px"
    :rules="rules"
    :hide-required-asterisk="false"
  >
    <el-row>
      <el-col :span="24">
        <div style="display: flex">
          <el-form-item label="项目名称" prop="xmbh" style="width: 50%">
            <el-select
              v-model="addForm.xmbh"
              filterable
              default-first-option
              style="width: 100%"
              placeholder="请选择项目"
              @change="handleChengeXm"
            >
              <el-option
                v-for="item in xmList"
                :key="item.xmbh"
                :label="item.xmjc"
                :value="item.xmbh"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分公司:" prop="bmmc" style="width: 30%">
            <div>{{ addForm.bmmc }}</div>
            <!-- <el-input
                  v-model="addForm.bmmc"
                  clearable
                  size="small"
                  style="width: 100%"
          /> -->
          </el-form-item>
          <el-form-item label="区域总监:" prop="qyzj" style="width: 30%">
            <div>{{ addForm.qyzj }}</div>
            <!-- <el-input
                  v-model="addForm.qyzj"
                  clearable
                  size="small"
                  style="width: 100%"
          /> -->
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="24">
        <el-form-item label="汇报事项" prop="matter">
          <el-select
            v-model="addForm.matter"
            filterable
            clearable
            default-first-option
            style="width: 100%"
            placeholder="请选择事项"
          >
            <el-option
              v-for="item in hbsxList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="汇报对象" prop="reporter">
          <el-select
            v-model="addForm.reporter"
            filterable
            clearable
            default-first-option
            style="width: 100%"
            placeholder="请选择汇报对象"
          >
            <el-option
              v-for="item in hbdxList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="通知到" prop="notifier">
          <el-select
            v-model="addForm.notifier"
            filterable
            multiple
            style="width: 100%"
            placeholder="请选择汇报对象"
          >
            <el-option
              v-for="item in hbdxList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="汇报内容：" prop="content" key="13">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            clearable
            placeholder="请输入汇报内容"
            v-model="addForm.content"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <div style="display: flex">
          <el-form-item label="汇报时间" prop="reporttime" style="width: 30%">
            <el-date-picker
              v-model="addForm.reporttime"
              type="date"
              style="width: 150px"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择汇报日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>

          <el-form-item prop="reportstarttime" style="width: 30%">
            <el-time-picker
              v-model="addForm.reportstarttime"
              style="width: 150px"
              value-format="HH:mm:ss"
              placeholder="选择开始时间"
            >
              :picker-options="pickerOptionsStart"
            </el-time-picker>
          </el-form-item>
          <el-form-item prop="reportendtime" style="width: 30%">
            <el-time-picker
              v-model="addForm.reportendtime"
              style="width: 150px"
              value-format="HH:mm:ss"
              placeholder="选择结束时间"
            >
              :picker-options="pickerOptionsEnd"
            </el-time-picker>
          </el-form-item>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "moment/locale/zh-cn";
import moment from "moment";
import { mapGetters } from "vuex";
import { getXmxxList } from "@/api/itWeekly";
import { getHbyyXmxx, saveHbyy } from "@/api/hbyy.js";

export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "user", "question"]),
  },
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },

      rules: {
        xmbh: [
          { required: true, message: "项目编号不能为空", trigger: "change" },
        ],
        matter: [
          { required: true, message: "汇报事项不能为空", trigger: "change" },
        ],
        content: [
          { required: true, message: "汇报内容不能为空", trigger: "change" },
        ],
        reporter: [
          { required: true, message: "汇报对象不能为空", trigger: "change" },
        ],
        reporttime: [
          { required: true, message: "汇报日期不能为空", trigger: "change" },
        ],
        reportstarttime: [
          {
            required: true,
            message: "汇报开始时间不能为空",
            trigger: "change",
          },
        ],
        reportendtime: [
          {
            required: true,
            message: "汇报结束时间不能为空",
            trigger: "change",
          },
        ],
      },
      list: [],
      loading: false,
      addForm: {
        xmbh: null,
        qyzj: null,
        matter: null,
        content: null,
        reporter: null,
        notifier: null,
        bmmc: null,
      },
      hbsxList: [],
      hbdx: [],
      hbdxList: [],
      xmList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      pickerOptionsTime: {},
      userList: [],
      btnDisable: true,
    };
  },

  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    getXmxxList("DS", "1", "1", null, "").then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });
  },
  mounted() {},
  methods: {
    handleChengeXm(e) {
      this.isHasProject();
    },
    isHasProject() {
      if (this.addForm.xmbh) {
        getHbyyXmxx({ xmbh: this.addForm.xmbh }).then((res) => {
          if (res.code == 0) {
            if (res.data != 0) {
              this.addForm.bmmc = res.data.bmmc;
              this.addForm.qyzj = res.data.qyzj;
              this.addForm.matter = null;
              // this.addForm.content=null;
              this.addForm.reporter = null;
              this.addForm.notifier = null;
              this.hbsxList = res.data.hbsxs;
              this.hbdxList = res.data.hbdx;
            }
          }
        });
      }
    },

    handleAdd() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let qsrq = this.addForm.reportstarttime;
          let jsrq = this.addForm.reportendtime;
          if (time_to_sec(qsrq) > time_to_sec(jsrq)) {
            this.$message.error("开始时间不能大于结束时间！");
            return false;
          }
          function time_to_sec(time) {
            if (time !== null) {
              var s = "";
              var hour = time.split(":")[0];
              var min = time.split(":")[1];
              var sec = time.split(":")[2];
              s = Number(hour * 3600) + Number(min * 60) + Number(sec);
              return s;
            }
          }
          this.addForm.notifier = this.addForm.notifier
            ? this.addForm.notifier.join(",")
            : null;
          this.addForm.reportstarttime =
            this.addForm.reporttime + " " + this.addForm.reportstarttime;
          this.addForm.reportendtime =
            this.addForm.reporttime + " " + this.addForm.reportendtime;
          saveHbyy(this.addForm).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.$emit("giveFather", this.parentDialog);
            } else {
              this.$message.error(res.msg);
              this.addForm.matter = null;
              this.addForm.notifier = null;
              this.addForm.reporter = null;
              this.addForm.reportstarttime = null;
              this.addForm.reportendtime = null;
            }
          });
        } else {
          this.$message.error("请填写表单必填项再保存！");
          return false;
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
.form {
  padding: 15px;
}
</style>